

export default function ErrorElement() {
    return <>
        <div className="container body-text">
            <h1>That page doesn't exist or something out of your control went wrong. Please try again.</h1>
        </div>
    </>
}